import React, { useEffect, useRef, useState } from "react";
import { sectionFrame } from "../../config/site";
import { trackCards, type TrackTab } from "../../content/site";
import { trackEvent } from "../../lib/analytics";
import { SectionHeading } from "../ui/SectionHeading";
import { TrackCard } from "../ui/TrackCard";

type TracksSectionProps = {
    onTrackSelect: (tab: TrackTab) => void;
    onNavigate: (id: string) => void;
};

export function TracksSection({ onTrackSelect, onNavigate }: TracksSectionProps) {
    const [openCardId, setOpenCardId] = useState<string | null>(null);
    const cardsRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handlePointerDown = (event: PointerEvent) => {
            if (!cardsRef.current?.contains(event.target as Node)) {
                setOpenCardId(null);
            }
        };

        document.addEventListener("pointerdown", handlePointerDown);

        return () => {
            document.removeEventListener("pointerdown", handlePointerDown);
        };
    }, []);

    return (
        <section id="tracks" className="px-4 pt-[120px] sm:px-6 max-md:pt-[84px]">
            <div className={sectionFrame}>
                <SectionHeading label="Направления" title="6 треков на твой выбор" />
                <div
                    ref={cardsRef}
                    className="grid gap-6 max-[639px]:gap-4 md:grid-cols-2 xl:grid-cols-3"
                >
                    {trackCards.map((card) => (
                        <TrackCard
                            key={card.id}
                            {...card}
                            isFlipped={openCardId === card.id}
                            onClick={() => {
                                trackEvent("track_speakers_open", {
                                    track: card.speakerTab,
                                    source: "card",
                                });
                                setOpenCardId(null);
                                onTrackSelect(card.speakerTab);
                                onNavigate("speakers");
                            }}
                            onFlipToggle={() => {
                                trackEvent("track_card_flip", { track: card.speakerTab });
                                setOpenCardId((current) => (current === card.id ? null : card.id));
                            }}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
